import { Route } from "@angular/router";
import { LectureBilanComponent } from "./lecture-bilan.component";

export const LectureBilanRouting: Route = {
  path: 'bilan',
  component: LectureBilanComponent,
  data: {
    breadcrumb: "Bilan des lectures"
  },
};
